/**
 * Central config for the KDP book "L'IA au service des enseignants".
 * Update KDP_ASIN with the real Amazon.fr ASIN when the book is
 * published. Everything else in the app reads from here.
 */

// Real ASIN once the book is live on Amazon.fr (e.g. "B0DXYZ1234").
// While null / falsy, the CTA buttons display a "Bientôt disponible"
// state and stay disabled instead of pointing to a dead placeholder.
// Paperback ASIN — book went live on Amazon.fr on 26 Sept 2026.
export const KDP_ASIN = "B0HL4MC23Y";
// Kindle e-book ASIN — same title, digital edition.
export const KDP_KINDLE_ASIN = "B0HL3YHYXP";

export const KDP_URL = KDP_ASIN
  ? `https://www.amazon.fr/dp/${KDP_ASIN}`
  : null;
export const KDP_KINDLE_URL = KDP_KINDLE_ASIN
  ? `https://www.amazon.fr/dp/${KDP_KINDLE_ASIN}`
  : null;

export const KDP_AVAILABLE = Boolean(KDP_ASIN);
export const KDP_KINDLE_AVAILABLE = Boolean(KDP_KINDLE_ASIN);

export const KDP_TITLE = "L'IA au service des enseignants";
export const KDP_TAGLINE = "50 cas pratiques pour gagner 2 heures par jour";
export const KDP_PRICE_PAPERBACK_EUR = 14.99;
export const KDP_PRICE_KINDLE_EUR = 9.99;
